const state = {
  isDarkMode: localStorage.getItem('darkMode') === 'true'
 
};

const actions = {
  initDarkMode({ state }) {
    if (state.isDarkMode) {
      document.body.classList.add('dark-mode');
    }
  },

changeDarkMode({ commit }, { isDarkMode }) {
  commit('setDarkMode', { isDarkMode });

  // Save to localStorage
  localStorage.setItem('darkMode', isDarkMode);

  // Add or remove class correctly
  if (isDarkMode) {
    document.body.classList.add('dark-mode');
  } else {
    document.body.classList.remove('dark-mode');
  }
}
};

const getters = {};

const mutations = {
  setDarkMode(state, { isDarkMode }) {
    state.isDarkMode = isDarkMode;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
  